import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarMenu from "../Component/SideBarMenu";
import { Button } from "react-bootstrap";
import TopHeader from "../Component/TopHeader";
import UsersFilters from "../Component/Filters/UsersFilters";
import Pagination from "../Component/Pagination";
import { display } from "../../utils/helper";
import {
  getUsersListAction,
  updateUserStatusAction,
} from "../../Store/Actions/AdminActions";

const UsersList = () => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  const rightSidebar = useSelector((state) => state.auth.isRightSidebarOpen);
  const usersList = useSelector((state) => state.admin.users);

  const [shwoFilter, toggleShowFilter] = useState(false);
  const [delLoading, setDelLoading] = useState({});
  const [updateLoading, setUpdateLoading] = useState({});
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  const stripEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
    );

  const [pagging, setPagging] = useState({
    totalItems: 0,
    itemsPerPage: 15,
    currentPage: 1,
    totalPages: 1,
    nextPage: null,
    limit: 15,
  });

  const updateStatus = (id) => {
    if (!updateLoading[id]) {
      setUpdateLoading({ ...updateLoading, [id]: true });

      updateUserStatusAction({ id }, dispatch)
        .then((res) => {
          //
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          setUpdateLoading({ ...updateLoading, [id]: false });
        });
    }
  };
  const deleteBooking = (id) => {
    if (!delLoading) {
      setDelLoading({ ...delLoading, [id]: true });
    }
  };

  const getAdminUser = (page = 1, overrideFilters) => {
    if (!loading) {
      setLoading(true);

      const params = {
        page,
        limit: 15,
        ...stripEmpty(overrideFilters || filters),
      };

      getUsersListAction(params, dispatch)
        .then((res) => {
          if (res && res.type === "success" && res.pagination) {
            setPagging((prev) => ({ ...prev, ...res.pagination }));
          }
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const renderPagging = () => (
    <Pagination
      currentPage={pagging.currentPage || 1}
      totalPages={pagging.totalPages || 1}
      totalItems={pagging.totalItems}
      onPageChange={(p) => getAdminUser(p)}
    />
  );

  useEffect(() => {
    if (usersList.length === 0) {
      getAdminUser();
    }
  }, []);

  return (
    <div className={`app-wrapper ${menuState ? "open" : ""} `}>
      <SideBarMenu />

      <div className="content-wrapper">
        <TopHeader title="Users" />

        <div className="content">
          <div className="pageHeading d-flex">
            <div />

            <div className="extras align-self-center ml-auto">
              <span
                className="add"
                onClick={() => toggleShowFilter(!shwoFilter)}
              >
                <i className="fas fa-sliders fa-rotate-90" />
              </span>
            </div>
          </div>

          {shwoFilter && (
            <UsersFilters
              initial={filters}
              onApply={(values) => {
                setFilters(values);
                getAdminUser(1, values);
                toggleShowFilter(false);
              }}
            />
          )}

              <div className="data-listing">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th width="13%">Name</th>
                      <th width="18%">Email</th>
                      <th width="10%" className="text-center">
                        Phone
                      </th>
                      <th width="8%" className="text-center">
                        Status
                      </th>
                      <th width="8%" className="text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersList.length > 0 &&
                      usersList.map((item) => (
                        <tr key={`user-${item.id}`}>
                          <td>{display(item.name)}</td>
                          <td>{display(item.email)}</td>
                          <td className="text-center">
                            {display(item.phone)}
                          </td>
                          <td className="text-center ">
                            {item.blocked ? "Blocked" : "Active"}
                          </td>
                          <td>
                            <Button
                              onClick={() => updateStatus(item.id)}
                              className="btn solid mr-2 btn-rounded"
                            >
                              {updateLoading[item.id] && (
                                <i className="fas fa-spinner fa-spin" />
                              )}

                              {!updateLoading[item.id] && (
                                <>
                                  {item.blocked && (
                                    <i
                                      className="fas fa-times"
                                      title="Active Now"
                                    />
                                  )}
                                  {!item.blocked && (
                                    <i
                                      className="fas fa-check"
                                      title="Block Now"
                                    />
                                  )}
                                </>
                              )}
                            </Button>
                            {` `}

                            <Button
                              onClick={() => deleteBooking(item)}
                              className="btn solid btn-danger btn-rounded"
                            >
                              {!delLoading[item.id] && (
                                <i className="fas fa-trash" />
                              )}

                              {delLoading[item.id] && (
                                <i className="fas fa-spin fa-spinner" />
                              )}
                            </Button>
                          </td>
                        </tr>
                      ))}

                    {usersList.length === 0 && (
                      <tr>
                        <td colSpan="5">
                          <p className="text-center">No Users Available.</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {renderPagging()}
        </div>
      </div>
    </div>
  );
};

export default UsersList;
